<script setup>
import {onMounted, ref, watch} from 'vue'
import {codePreview, formatDate, showSuccessMessage, validatePhoneNumber} from '@/helper';
import {Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
import Textarea from '@/components/forms/Textarea.vue';
import Select from '@/components/forms/Select.vue';
import {authData} from '@/services/AuthService';
import Input from "@/components/forms/Input.vue";
import {createConfirmDialog} from "vuejs-confirm-dialog";
import ModalDialog from "@/components/modals/ModalDialog.vue";
import {useI18n} from "vue-i18n";
import FormTemplateService from "@/services/FormTemplateService";
import ClientService from "@/services/ClientService";
import SettingsService from "@/services/SettingsService";

const {t} = useI18n();

const props = defineProps({
  clientId: {type: Number, required: true},
});

const onboardingOptions = ref({investment_questionnaires: [], aml_questionnaires: [], forms: [], meeting_records: [], identification: false, client_complex_form: false, address: false, bank_account: false, documents: false, strategies: false});
const clientContracts = ref([]);
const categories = ref([]);

const isOpen = ref(true)
const emit = defineEmits(['confirm', 'cancel']);

const selectedOnboardingCategory = ref(null);
const onboardingSettings = ref(null);

onMounted(async () => {
  getOnboardingSettings();
  getClientContracts();
});

function getClientContracts() {
  ClientService.getClientContracts(props.clientId).then(response => {
        clientContracts.value = response;
      }
  )
}

function getOnboardingSettings() {
  return SettingsService.getOnboardingSettings()
      .then((response) => {
        categories.value = response;
      })
      .catch((error) => {
      });
}

const closeModalWith = (value) => {
  setTimeout(() => {
    if (value === 'confirm' && onboardingSettings.value) {
      emit('confirm', onboardingSettings.value);
      isOpen.value = false;
    } else {
      emit('cancel');
      isOpen.value = false;
    }
  }, 300);
}

function handleCategory() {

  onboardingSettings.value = selectedOnboardingCategory.value[0].settings;
  console.log(onboardingSettings.value);
}

function openModal() {
  isOpen.value = true
}
</script>

<template>
  <TransitionRoot appear :show="isOpen" as="template">
    <Dialog as="div" class="modal show d-block" style="z-index: 1055;">
      <div class="modal-backdrop fade show"></div>
      <div class="modal-dialog modal-dialog-centered modal-lg" style="z-index: 1055">
        <div class="modal-content">
          <DialogPanel class="modal-body p-4 rounded-lg shadow-lg">
            <div class="modal-header">
              <DialogTitle as="h3" class="modal-title">
                {{ t('clientsDetail.onboarding_options') }}
              </DialogTitle>
              <i class="btn-close cursor-pointer" @click="closeModalWith('cancel')" aria-label="Close"></i>
            </div>
            <form @submit.prevent="closeModalWith('confirm')">
              <div class="modal-body">
                <div class="row mb-3">
                  <div class="col-12 form-group">
                    <label for="parentId" class="form-label">{{ t('simplifiedAssistedOnboardingOptionsModal.aso_category') }}</label>
                    <select class="form-select" v-model="selectedOnboardingCategory" @change="handleCategory">
                      <option v-for="(category, index) in categories" :key="index" :value="[category]">{{ category.name }}</option>
                    </select>
                  </div>
                </div>

                <div v-if="onboardingSettings || onboardingSettings?.calculation" class="row mb-3">
                  <div class="col-12 form-group">
                    <label for="parentId" class="form-label">{{ t('simplifiedAssistedOnboardingOptionsModal.client_contracts') }}</label>
                    <select class="form-select" v-model="onboardingSettings.contract">
                      <option v-for="(clientContract, index) in clientContracts" :key="index" :value="clientContract.id">{{ clientContract.contractType + ' (' + clientContract.contract_number + ')' }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button class="btn btn-link text-decoration-underline text-dark" @click="closeModalWith('cancel')">{{ t('simplifiedAssistedOnboardingOptionsModal.cancel') }}</button>
                <button class="btn btn-primary btn-md" type="submit">{{ t('simplifiedAssistedOnboardingOptionsModal.save') }}</button>
              </div>
            </form>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
